import { CANtrackCase, CANtrackComment } from '../types/comment';

export function getCaseObjectFromComment(
	comment: CANtrackComment,
): CANtrackCase {
	return {
		id: comment.caseID,
		title: comment.caseTitle,
		customerID: comment.customerID,
		customerName: comment.customerName,
		gpd: {
			...comment.gpda,
		},
		description: 'NA',
		consultantID: 0,
		consultantName: 'NA',
	};
}
